module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tutorials":"Tutorials","learn":"Learn how to use","get-help":"Get help"},"pt-BR":{"tutorials":"Tutoriais","learn":"Aprendar a usar o sistema","get-help":"Consiga ajuda"}}')
  delete Component.options._Ctor
}
